import _find from 'lodash/find';
import _remove from 'lodash/remove';
import viewHappeningTemplate from './view-happening/view-happening.html';
import template from './happenings.html';

class HappeningsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $state,
    HappeningService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$state = $state;
    this.HappeningService = HappeningService;
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.happenings) {
      this.happenings = Object.assign([], this.happenings);
    }
  }

  view(id, ev) {
    const happening = _find(this.happenings, item => item.id === id);
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'ViewHappeningController',
      template: viewHappeningTemplate,
      clickOutsideToClose: true,
      locals: {happening},
      targetEvent: ev
    });
  }

  edit(id, ev) {
    ev.stopPropagation();
    const happening = this.getHappening(id);
    if (Number(happening.employee.id) !== this.me.employeeId) {
      return this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak uprawnień')
          .textContent('Nie możesz edytować wpisu, którego nie utworzyłeś.')
          .ariaLabel('Nie możesz edytować wpisu, którego nie utworzyłeś')
          .ok('Zamknij')
          .targetEvent(ev)
      );
    }

    this.$state.go('modules.happenings.edit', {id});
  }

  remove(id, ev) {
    ev.stopPropagation();
    const happening = this.getHappening(id);
    if (Number(happening.employee.id) !== this.me.employeeId) {
      return this.$mdDialog.show(
        this.$mdDialog.alert()
          .clickOutsideToClose(true)
          .title('Brak uprawnień')
          .textContent('Nie możesz usunąć wpisu, którego nie utworzyłeś.')
          .ariaLabel('Nie możesz usunąć wpisu, którego nie utworzyłeś')
          .ok('Zamknij')
          .targetEvent(ev)
      );
    }

    this.HappeningService.delete({data: id}).then(() => {
      _remove(this.happenings, happening => happening.id === id);
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Usunięto wydarzenie')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  getHappening(id) {
    return _find(this.happenings, happening => happening.id === id);
  }
}

export const Happenings = {
  bindings: {
    me: '<',
    happenings: '<'
  },
  template,
  controller: HappeningsComponent
};
